import React, { useEffect, useState } from 'react'

export default function useAdConsent() {
    const [consent, setConsent] = useState(window.adConsented);

    useEffect(() => {
        if (typeof consent == 'undefined') {
            var timer = setTimeout(() => {
                
                setConsent(!!window.adConsented);
            }, 250);

            return () => {
                clearTimeout(timer);
            }
        }
    }, []);

    return consent;
}